import SampleTextChangeEvent from '@adobe-fonts/site/events/SampleTextChangeEvent.js';

export function registerEventHandlers(element) {
  element.addEventListener(SampleTextChangeEvent.EVENT_NAME, event => handleSampleTextChange(event, element));
}

/**
 * Change the sample text on the parent's elements if they have the data attribute `data-editable-sample`
 *
 * @param {SampleTextChangeEvent} event
 */
export function handleSampleTextChange(event, parent) {
  if (!(event instanceof SampleTextChangeEvent)) {
    return;
  }

  const sampleText = event.detail.sampleText;
  const samples = parent.querySelectorAll('[data-editable-sample]');

  samples.forEach(function(sample) {
    sample.setAttribute('previewstring', sampleText);
    sample.innerText = sampleText;
  });
}
